import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_idea-hub-409/artifacts/nuax2p04_ChatGPT%20Image%20Jul%206%2C%202026%2C%2006_16_37%20PM.png";

export const EMERGENT_URL = "https://app.emergent.sh";

export const fetchCategories = async () => {
  const { data } = await axios.get(`${API}/categories`);
  return data;
};

export const fetchCategory = async (slug) => {
  const { data } = await axios.get(`${API}/categories/${slug}`);
  return data;
};

export const voteCategory = async (slug) => {
  const { data } = await axios.post(`${API}/categories/${slug}/vote`, {});
  return data;
};

export const fetchTrendingCategories = async () => {
  const { data } = await axios.get(`${API}/categories-trending`);
  return data;
};

export const fetchBusinesses = async ({ category, search } = {}) => {
  const params = {};
  if (category) params.category = category;
  if (search) params.search = search;
  const { data } = await axios.get(`${API}/businesses`, { params });
  return data;
};

// Paginated fetch — returns { items, total, offset, limit, has_more }.
export const fetchBusinessesPage = async ({ category, search, limit = 30, offset = 0 } = {}) => {
  const params = { limit, offset };
  if (category) params.category = category;
  if (search) params.search = search;
  const { data } = await axios.get(`${API}/businesses`, { params });
  return data;
};

export const fetchBusiness = async (id) => {
  const { data } = await axios.get(`${API}/businesses/${id}`);
  return data;
};

export const createStarterBuild = async (payload) => {
  const { data } = await axios.post(`${API}/starter-builds`, payload, { withCredentials: true });
  return data;
};

export const fetchStarterBuilds = async () => {
  const { data } = await axios.get(`${API}/starter-builds`, { withCredentials: true });
  return data;
};

export const fetchStarterBuild = async (id) => {
  const { data } = await axios.get(`${API}/starter-builds/${id}`, { withCredentials: true });
  return data;
};

export const updateStarterBuild = async (id, status) => {
  const { data } = await axios.patch(`${API}/starter-builds/${id}`, { status }, { withCredentials: true });
  return data;
};

export const fetchNotebook = async () => {
  const { data } = await axios.get(`${API}/notebook`, { withCredentials: true });
  return data;
};

export const saveNotebook = async (payload) => {
  const { data } = await axios.put(`${API}/notebook`, payload, { withCredentials: true });
  return data;
};

export const subscribePro = async () => {
  const { data } = await axios.post(`${API}/pro/subscribe`, {}, { withCredentials: true });
  return data;
};

export const createCheckout = async (payload) => {
  const { data } = await axios.post(
    `${API}/payments/checkout`,
    { origin_url: window.location.origin, ...payload },
    { withCredentials: true }
  );
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`, { withCredentials: true });
  return data;
};

export const createPreviewRequest = async (payload) => {
  const { data } = await axios.post(`${API}/preview-projects/request`, payload, { withCredentials: true });
  return data;
};

export const previewCheckout = async (requestId) => {
  const { data } = await axios.post(
    `${API}/preview-projects/${requestId}/checkout`,
    { origin_url: window.location.origin },
    { withCredentials: true }
  );
  return data;
};

export const fetchMyPreviewProjects = async () => {
  const { data } = await axios.get(`${API}/preview-projects/mine`, { withCredentials: true });
  return data;
};

export const fetchMyPreviewRequests = async () => {
  const { data } = await axios.get(`${API}/preview-projects/requests/mine`, { withCredentials: true });
  return data;
};

export const notifyInterest = async (service) => {
  const { data } = await axios.post(`${API}/notify-interest`, { service }, { withCredentials: true });
  return data;
};

export const adminNotifications = async () => {
  const { data } = await axios.get(`${API}/admin/notifications`, { headers: adminHeaders() });
  return data;
};
export const adminNotificationsRead = async () => {
  const { data } = await axios.post(`${API}/admin/notifications/read`, {}, { headers: adminHeaders() });
  return data;
};

export const adminListRequests = async (params = {}) => {
  const { data } = await axios.get(`${API}/admin/requests`, { params, headers: adminHeaders() });
  return data;
};
export const adminUsers = async () => {
  const { data } = await axios.get(`${API}/admin/users`, { headers: adminHeaders() });
  return data;
};
export const adminDeleteUser = async (userId) => {
  const { data } = await axios.delete(`${API}/admin/users/${userId}`, { headers: adminHeaders() });
  return data;
};
export const adminAcceptRequest = async (id) => {
  const { data } = await axios.post(`${API}/admin/requests/${id}/accept`, {}, { headers: adminHeaders() });
  return data;
};
export const adminDeclineRequest = async (id, reason) => {
  const { data } = await axios.post(`${API}/admin/requests/${id}/decline`, { reason }, { headers: adminHeaders() });
  return data;
};

export const fetchPreviewProject = async (id) => {
  const { data } = await axios.get(`${API}/preview-projects/${id}`, { withCredentials: true });
  return data;
};

// ---------------- Admin Command Center ----------------
export const getAdminToken = () => localStorage.getItem("lbs_admin_token");
export const setAdminToken = (t) =>
  t ? localStorage.setItem("lbs_admin_token", t) : localStorage.removeItem("lbs_admin_token");
const adminHeaders = () => {
  const t = getAdminToken();
  return t ? { "X-Admin-Token": t } : {};
};

export const adminCheck = async () => {
  const { data } = await axios.get(`${API}/admin/check`, { withCredentials: true, headers: adminHeaders() });
  return data;
};
export const adminAuth = async (code) => {
  const { data } = await axios.post(`${API}/admin/auth`, { code }, { withCredentials: true });
  return data;
};
export const adminLogout = async () => {
  try {
    await axios.post(`${API}/admin/logout`, {}, { headers: adminHeaders() });
  } catch {
    /* ignore */
  }
  setAdminToken(null);
};
export const adminStats = async () => {
  const { data } = await axios.get(`${API}/admin/stats`, { headers: adminHeaders() });
  return data;
};
export const adminSalesSummary = async () => {
  const { data } = await axios.get(`${API}/admin/sales-summary`, { headers: adminHeaders() });
  return data;
};
export const adminListProjects = async (params = {}) => {
  const { data } = await axios.get(`${API}/admin/projects`, { params, headers: adminHeaders() });
  return data;
};
export const adminGetProject = async (id) => {
  const { data } = await axios.get(`${API}/admin/projects/${id}`, { headers: adminHeaders() });
  return data;
};
export const adminUpdateProject = async (id, payload) => {
  const { data } = await axios.patch(`${API}/admin/projects/${id}`, payload, { headers: adminHeaders() });
  return data;
};
export const adminPromoteToCB = async (id) => {
  const { data } = await axios.post(`${API}/admin/projects/${id}/promote-to-cb`, {}, { headers: adminHeaders() });
  return data;
};

// ---------------- Continue Building Program ----------------
export const fetchCBPlan = async () => {
  const { data } = await axios.get(`${API}/continue-building/plan`);
  return data;
};
export const fetchMyContinueBuilding = async () => {
  const { data } = await axios.get(`${API}/continue-building/mine`, { withCredentials: true });
  return data;
};
export const subscribeContinueBuilding = async (payload = {}) => {
  const { data } = await axios.post(
    `${API}/continue-building/subscribe`,
    { origin_url: window.location.origin, ...payload },
    { withCredentials: true }
  );
  return data;
};
export const saveCBDeployment = async (payload) => {
  const { data } = await axios.post(`${API}/continue-building/deployment`, payload, { withCredentials: true });
  return data;
};
export const uploadStudioFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/studio/upload`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return `${API}/studio/file/${data.id}`;
};

// Admin — Continue Building Manager
export const adminCBList = async (params = {}) => {
  const { data } = await axios.get(`${API}/admin/continue-building`, { params, headers: adminHeaders() });
  return data;
};
export const adminCBGet = async (id) => {
  const { data } = await axios.get(`${API}/admin/continue-building/${id}`, { headers: adminHeaders() });
  return data;
};
export const adminCBUpdate = async (id, payload) => {
  const { data } = await axios.patch(`${API}/admin/continue-building/${id}`, payload, { headers: adminHeaders() });
  return data;
};
export const adminCBAddPhase = async (id, payload) => {
  const { data } = await axios.post(`${API}/admin/continue-building/${id}/phases`, payload, { headers: adminHeaders() });
  return data;
};
export const adminCBUpdatePhase = async (id, phaseId, payload) => {
  const { data } = await axios.patch(`${API}/admin/continue-building/${id}/phases/${phaseId}`, payload, { headers: adminHeaders() });
  return data;
};
export const adminCBDeletePhase = async (id, phaseId) => {
  const { data } = await axios.delete(`${API}/admin/continue-building/${id}/phases/${phaseId}`, { headers: adminHeaders() });
  return data;
};
export const adminCBReorder = async (id, phaseIds) => {
  const { data } = await axios.post(`${API}/admin/continue-building/${id}/phases/reorder`, { phase_ids: phaseIds }, { headers: adminHeaders() });
  return data;
};
export const adminCBGetSettings = async () => {
  const { data } = await axios.get(`${API}/admin/continue-building-settings`, { headers: adminHeaders() });
  return data;
};
export const adminCBUpdateSettings = async (payload) => {
  const { data } = await axios.patch(`${API}/admin/continue-building-settings`, payload, { headers: adminHeaders() });
  return data;
};

// ---------------- Billing (real Stripe) ----------------
export const getBillingConfig = async () => {
  const { data } = await axios.get(`${API}/billing/config`);
  return data;
};
export const billingCheckout = async (plan) => {
  const { data } = await axios.post(`${API}/billing/checkout`, { plan, origin_url: window.location.origin }, { withCredentials: true });
  return data;
};
export const billingStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/billing/status/${sessionId}`, { withCredentials: true });
  return data;
};
export const createSetupIntent = async () => {
  const { data } = await axios.post(`${API}/billing/setup-intent`, {}, { withCredentials: true });
  return data;
};
export const setDefaultPaymentMethod = async (id) => {
  const { data } = await axios.post(`${API}/billing/payment-methods/${id}/default`, {}, { withCredentials: true });
  return data;
};

// ---------------- Account Center ----------------
export const getSubscription = async () => {
  const { data } = await axios.get(`${API}/billing/subscription`, { withCredentials: true });
  return data;
};
export const cancelSubscription = async () => {
  const { data } = await axios.post(`${API}/billing/subscription/cancel`, {}, { withCredentials: true });
  return data;
};
export const resumeSubscription = async () => {
  const { data } = await axios.post(`${API}/billing/subscription/resume`, {}, { withCredentials: true });
  return data;
};

export const getPaymentMethods = async () => {
  const { data } = await axios.get(`${API}/billing/payment-methods`, { withCredentials: true });
  return data;
};
export const deletePaymentMethod = async (id) => {
  const { data } = await axios.delete(`${API}/billing/payment-methods/${id}`, { withCredentials: true });
  return data;
};

export const getInvoices = async () => {
  const { data } = await axios.get(`${API}/billing/invoices`, { withCredentials: true });
  return data;
};
export const downloadInvoicePdf = async (id, number, pdfUrl) => {
  if (pdfUrl) {
    window.open(pdfUrl, "_blank", "noopener");
    return;
  }
  const res = await axios.get(`${API}/account/invoices/${id}/pdf`, { withCredentials: true, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${number || "invoice"}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getAccountProjects = async () => {
  const { data } = await axios.get(`${API}/account/projects`, { withCredentials: true });
  return data;
};

// ---------------- Blueprint AI ----------------
export const blueprintAdvice = async (question, answer) => {
  const { data } = await axios.post(`${API}/blueprint/advice`, { question, answer });
  return data.advice;
};
export const blueprintRecommend = async (payload) => {
  const { data } = await axios.post(`${API}/blueprint/recommend`, payload);
  return data;
};
export const blueprintGenerate = async (payload) => {
  const { data } = await axios.post(`${API}/blueprint/generate`, payload);
  return data.blueprint;
};
export const blueprintImprove = async (blueprint, instruction) => {
  const { data } = await axios.post(`${API}/blueprint/improve`, { blueprint, instruction });
  return data.blueprint;
};
export const blueprintMarket = async (problem, audience) => {
  const { data } = await axios.post(`${API}/blueprint/market`, { problem, audience });
  return data;
};
export const workflowAudit = async (profession) => {
  const { data } = await axios.post(`${API}/workflow/audit`, { profession });
  return data;
};
export const workflowSearch = async (query, profession) => {
  const { data } = await axios.post(`${API}/workflow/search`, { query, profession });
  return data.workflow;
};
export const workflowExpand = async (task, profession) => {
  const { data } = await axios.post(`${API}/workflow/expand`, { task, profession });
  return data.workflow;
};
export const workflowExplain = async (name, description, tools) => {
  const { data } = await axios.post(`${API}/workflow/explain`, { name, description, tools });
  return data;
};
export const workflowCountryIdeas = async (payload) => {
  const { data } = await axios.post(`${API}/workflow/country-ideas`, payload);
  return data;
};
export const workflowSmallBusinessIdeas = async (payload) => {
  const { data } = await axios.post(`${API}/workflow/small-business-ideas`, payload);
  return data;
};

// ---- AI Resources ----
export const aiToolStack = async (building) => {
  const { data } = await axios.post(`${API}/ai/tool-stack`, { building });
  return data;
};
export const aiToolRecommend = async (goal) => {
  const { data } = await axios.post(`${API}/ai/tool-recommend`, { goal });
  return data;
};
export const aiValidate = async (form) => {
  const { data } = await axios.post(`${API}/ai/validate`, form);
  return data;
};
export const aiRoadmap = async (form) => {
  const { data } = await axios.post(`${API}/ai/roadmap`, form);
  return data;
};
export const aiCompetitors = async (idea) => {
  const { data } = await axios.post(`${API}/ai/competitors`, { idea });
  return data;
};
export const aiMarketInsights = async (payload) => {
  const { data } = await axios.post(`${API}/ai/market-insights`, payload);
  return data;
};
export const aiNameCheck = async (name) => {
  const { data } = await axios.post(`${API}/ai/name-check`, { name });
  return data;
};
export const aiNameSuggestions = async (name, exclude = []) => {
  const { data } = await axios.post(`${API}/ai/name-suggestions`, { name, exclude });
  return data;
};
export const aiOpportunityScan = async (payload) => {
  const { data } = await axios.post(`${API}/ai/opportunity-scan`, payload);
  return data;
};

// ---- Founder Resource Library ----
export const resourcesLibrary = async () => {
  const { data } = await axios.get(`${API}/resources/library`);
  return data;
};
export const resourcesRequest = async (payload) => {
  const { data } = await axios.post(`${API}/resources/request`, payload);
  return data;
};
export const resourcesFavorites = async () => {
  const { data } = await axios.get(`${API}/resources/favorites`, { withCredentials: true });
  return data;
};
export const resourcesToggleFavorite = async (toolId, on) => {
  const { data } = await axios.post(`${API}/resources/favorite`, { tool_id: toolId, on }, { withCredentials: true });
  return data;
};
export const aiSave = async (kind, payloadData) => {
  const { data } = await axios.post(`${API}/ai/save`, { kind, data: payloadData }, { withCredentials: true });
  return data;
};
export const formationFinder = async (payload) => {
  const { data } = await axios.post(`${API}/ai/formation-finder`, payload);
  return data;
};
export const aiListSaved = async (kind) => {
  const { data } = await axios.get(`${API}/ai/saved`, { params: kind ? { kind } : {}, withCredentials: true });
  return data.items;
};
export const aiDeleteSaved = async (id) => {
  const { data } = await axios.delete(`${API}/ai/saved/${id}`, { withCredentials: true });
  return data;
};
export const aiUpdateSaved = async (id, payloadData) => {
  const { data } = await axios.patch(`${API}/ai/saved/${id}`, { data: payloadData }, { withCredentials: true });
  return data;
};

// ---- LaunchBS Academy (Learn) ----
export const learnCatalog = async () => {
  const { data } = await axios.get(`${API}/learn/catalog`);
  return data;
};
export const learnLesson = async (id) => {
  const { data } = await axios.get(`${API}/learn/lesson/${id}`);
  return data;
};
export const learnProgress = async () => {
  const { data } = await axios.get(`${API}/learn/progress`, { withCredentials: true });
  return data;
};
export const learnComplete = async (id) => {
  const { data } = await axios.post(`${API}/learn/lesson/${id}/complete`, {}, { withCredentials: true });
  return data;
};

// ---- Founder Success Roadmap ----
export const roadmapCatalog = async () => {
  const { data } = await axios.get(`${API}/roadmap/catalog`);
  return data;
};
export const roadmapProgress = async () => {
  const { data } = await axios.get(`${API}/roadmap/progress`, { withCredentials: true });
  return data;
};
export const roadmapToggleTask = async (stageKey, taskIndex, done) => {
  const { data } = await axios.post(`${API}/roadmap/task`, { stage_key: stageKey, task_index: taskIndex, done }, { withCredentials: true });
  return data;
};

// ---- Ready-to-Build Startups ----
export const fetchStartups = async () => {
  const { data } = await axios.get(`${API}/startups`, { withCredentials: true });
  return data;
};
export const fetchMyStartups = async () => {
  const { data } = await axios.get(`${API}/startups/mine`, { withCredentials: true });
  return data.startups;
};
export const fetchStartup = async (id) => {
  const { data } = await axios.get(`${API}/startups/${id}`);
  return data;
};
export const fetchStartupOptions = async () => {
  const { data } = await axios.get(`${API}/startups/options`);
  return data;
};
export const fetchStartupAccess = async (id) => {
  const { data } = await axios.get(`${API}/startups/${id}/access`, { withCredentials: true });
  return data;
};
export const fetchStartupDocuments = async (id) => {
  const { data } = await axios.get(`${API}/startups/${id}/documents`, { withCredentials: true });
  return data.documents;
};
export const downloadStartupDocument = async (sid, doc) => {
  const res = await axios.get(`${API}/startups/${sid}/documents/${doc.id}/download`, { responseType: "blob", withCredentials: true });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: doc.content_type }));
  const a = document.createElement("a");
  a.href = url; a.download = doc.filename;
  document.body.appendChild(a); a.click(); a.remove();
  window.URL.revokeObjectURL(url);
};
export const startupCheckout = async (startupId) => {
  const { data } = await axios.post(`${API}/payments/checkout`, { product_type: "startup", startup_id: startupId, origin_url: window.location.origin }, { withCredentials: true });
  return data;
};
// admin
export const adminListStartups = async () => (await axios.get(`${API}/admin/startups`, { withCredentials: true, headers: adminHeaders() })).data.startups;
export const adminCreateStartup = async (payload) => (await axios.post(`${API}/admin/startups`, payload, { withCredentials: true, headers: adminHeaders() })).data;
export const adminUpdateStartup = async (id, payload) => (await axios.put(`${API}/admin/startups/${id}`, payload, { withCredentials: true, headers: adminHeaders() })).data;
export const adminDeleteStartup = async (id) => (await axios.delete(`${API}/admin/startups/${id}`, { withCredentials: true, headers: adminHeaders() })).data;
export const adminListStartupDocs = async (id) => (await axios.get(`${API}/admin/startups/${id}/documents`, { withCredentials: true, headers: adminHeaders() })).data.documents;
export const adminUploadStartupDoc = async (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await axios.post(`${API}/admin/startups/${id}/documents`, fd, { withCredentials: true, headers: { ...adminHeaders(), "Content-Type": "multipart/form-data" } })).data;
};
export const adminDeleteStartupDoc = async (id, docId) => (await axios.delete(`${API}/admin/startups/${id}/documents/${docId}`, { withCredentials: true, headers: adminHeaders() })).data;
export const downloadBlueprintPdf = async (blueprint) => {
  const res = await axios.post(`${API}/blueprint/pdf`, { blueprint }, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(blueprint.project_name || "blueprint").replace(/\s+/g, "_")}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
export const downloadLaunchPlanPdf = async (blueprint) => {
  const res = await axios.post(`${API}/ai/launch-plan-pdf`, { blueprint }, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(blueprint.project_name || "launch_plan").replace(/\s+/g, "_")}_Launch_Plan.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
export const saveBlueprint = async (payload) => {
  const { data } = await axios.post(`${API}/blueprints`, payload, { withCredentials: true });
  return data;
};
export const listBlueprints = async () => {
  const { data } = await axios.get(`${API}/blueprints`, { withCredentials: true });
  return data;
};
export const getBlueprint = async (id) => {
  const { data } = await axios.get(`${API}/blueprints/${id}`, { withCredentials: true });
  return data;
};
export const deleteBlueprint = async (id) => {
  const { data } = await axios.delete(`${API}/blueprints/${id}`, { withCredentials: true });
  return data;
};

// ---------------- Founder Compass ----------------
export const compassRecommend = async (answers, excludeIds = []) => {
  const { data } = await axios.post(`${API}/compass/recommend`, { answers, exclude_ids: excludeIds });
  return data;
};
export const compassEvent = async (event, data = {}) => {
  try { await axios.post(`${API}/compass/event`, { event, data }); } catch { /* non-blocking */ }
};

// ---- LaunchBS AI Scanner: mobile handoff + History / Collections / Favorites ----
export const getScanHandoff = async (id) => {
  const { data } = await axios.get(`${API}/scan-handoff/${id}`);
  return data;
};
export const createScanHandoff = async (payload) => {
  const { data } = await axios.post(`${API}/scan-handoff`, payload);
  return data;
};
export const listScanHistory = async () => {
  const { data } = await axios.get(`${API}/scanner/history`, { withCredentials: true });
  return data;
};
export const saveScanHistory = async (payload) => {
  const { data } = await axios.post(`${API}/scanner/history`, payload, { withCredentials: true });
  return data;
};
export const deleteScanHistory = async (id) => {
  const { data } = await axios.delete(`${API}/scanner/history/${id}`, { withCredentials: true });
  return data;
};
export const listScanCollections = async () => {
  const { data } = await axios.get(`${API}/scanner/collections`, { withCredentials: true });
  return data;
};
export const createScanCollection = async (name, emoji = "📁") => {
  const { data } = await axios.post(`${API}/scanner/collections`, { name, emoji }, { withCredentials: true });
  return data;
};
export const deleteScanCollection = async (id) => {
  const { data } = await axios.delete(`${API}/scanner/collections/${id}`, { withCredentials: true });
  return data;
};
export const listScanFavorites = async (collectionId) => {
  const params = collectionId !== undefined ? { collection_id: collectionId } : {};
  const { data } = await axios.get(`${API}/scanner/favorites`, { params, withCredentials: true });
  return data;
};
export const saveScanFavorite = async (idea, collectionId = "") => {
  const { data } = await axios.post(`${API}/scanner/favorites`, { idea, collection_id: collectionId }, { withCredentials: true });
  return data;
};
export const deleteScanFavorite = async (id) => {
  const { data } = await axios.delete(`${API}/scanner/favorites/${id}`, { withCredentials: true });
  return data;
};

export const getBillingInfo = async () => {
  const { data } = await axios.get(`${API}/account/billing`, { withCredentials: true });
  return data;
};
export const updateBillingInfo = async (payload) => {
  const { data } = await axios.put(`${API}/account/billing`, payload, { withCredentials: true });
  return data;
};
